import React from 'react'

import { ConfirmationModal, T } from 'src/govwell-ui'

type Props = {
  onClose: () => void
  onDelete: () => Promise<void>
}

const DeleteLetterheadModal = ({ onClose, onDelete }: Props) => {
  return (
    <ConfirmationModal
      title="Delete Letterhead"
      cancelText="Cancel"
      confirmText="Delete letterhead"
      isDestructive
      onCancel={onClose}
      onConfirm={onDelete}
    >
      <T.Body>
        Are you sure you want to delete this letterhead? This action cannot be undone.
      </T.Body>
    </ConfirmationModal>
  )
}

export default React.memo(DeleteLetterheadModal)
